import {Component, Input} from '@angular/core';

@Component({
  selector: 'mc-notification-manager',
  templateUrl: './notification-manager.component.html',
  styleUrls: ['./notification-manager.component.scss'],
})
export class NotificationManagerComponent {
  @Input() title: string;
  @Input() name: string;
  @Input() email: string;
  @Input() phone: string;
}
